import { TranslateButtonController } from "./translate-button.controller";

angular
    .module("thor.shared.translations.translate-button.component", [])
    .component("translateButton", {
        bindings: {
            getTranslationStatus: "&",
            setTranslationStatus: "&",
            fetchAll: "&",
            initiatePublish: "&",
            isPublishDisabled: "<",
            isSaving: "<",
            resourceId: "<",
            translationsStatus: "<"
        },
        controller: TranslateButtonController,
        template: require("./translate-button.html")
    });
